import {maybeLoadGmaps} from "../../../../packages/javascript/maybe-load-gmaps/index";

export function setupAutocomplete($) {
    var addresses = $('.autocomplete-us');
    var addressData = {};
    var i = 1;

    if ( ! addresses.length) {
        return;
    }

    if ( ! window.onCarrot) {
        window.onCarrot = {};
    }

    addresses.each(function() {
        var address = {};
        var addressID = 'autocomplete-us-' + i;

        $(this).hide();

        address.street_number = {
            id: $(this).find('.address_line_1 > input').attr('id'),
            value: 'short_name'
        };
        address.route = {
            id: $(this).find('.address_line_2 > input').attr('id'),
            value: 'short_name'
        };
        address.locality = {
            id: $(this).find('.address_city > input').attr('id'),
            value: 'long_name'
        };
        address.administrative_area_level_1 = {
            id: $(this).find('.address_state > select').attr('id'),
            value: 'long_name'
        };
        address.postal_code = {
            id: $(this).find('.address_zip > input').attr('id'),
            value: 'long_name'
        };

        addressData[addressID] = address;

        var label = $(this).find('.gfield_label');
        var classes = $(this).attr('class');
        var placeholder = $(this).find('.address_line_1 input').attr('placeholder');
        var description = $(this).find('.gfield_description').wrap('<div>').parent();

        var autolocateHTML = "<li class='"+ classes +"'>" +
            "<label class='gfield_label' for='"+ addressID +"'>"+ label.html() +"</label>" +
            "<input type='text' id='"+ addressID +"' class='ginput_full autocomplete-address' placeholder='"+ (placeholder ? placeholder : "") +"'>" +
            description.html();

        $(autolocateHTML).insertBefore($(this));

        function chromeForceDisableAutocomplete(el) {
          // NOTE: oncarrot/oncarrot-docs/notes/address-autocomplete-debugging.md
          if (navigator.userAgent.indexOf("Chrome") !== -1 && el.getAttribute('autocomplete') === 'off') {
            el.setAttribute('autocomplete', 'new-password')
          }
        }

        // Prevent pressing enter when selecting an address to submit the form
        $('#' + addressID)
          .keydown(function(e) {
            chromeForceDisableAutocomplete(e.target);

            if (e.keyCode == 13) {
              e.preventDefault();
            }
          })
          .focus(function(e) {
            chromeForceDisableAutocomplete(e.target);
          });

        i++;
    });

    // Add address ID's to main window to be accessible for Google autocomplete functions
    window.onCarrot.addresses = addressData;

    maybeLoadGmaps({jQuery: $})
        .then(function () {
            initAutocomplete();
        })
        .catch(function (e) {
            console.log('error loading gmaps in carrot gf address autocomplete');
            throw e;
        })
}

/**
 * Google Places Autocomplete functions
 */
var autocompleteAddresses = {};

export function initAutocomplete() {
  // Create the autocomplete object, restricting the search to geographical
  // location types.
  if (window.onCarrot && window.onCarrot.addresses) {
    var addresses = window.onCarrot.addresses;
    Object.keys(addresses).forEach(function (addressID) {
        var autocomplete = new google.maps.places.Autocomplete(
            document.getElementById(addressID),
            {types: ['geocode']}
        );

        // When the user selects an address from the dropdown, populate the address
        // fields in the form.
        addAutoCompleteListener(autocomplete, addressID);

        autocompleteAddresses[addressID] = autocomplete;
    })
  }

}

export function addAutoCompleteListener(autocomplete, addressID) {
  autocomplete.addListener('place_changed', function() {
    var place = autocomplete.getPlace();
    fillInAddress(addressID, place);
  });
}

export function fillInAddress(addressID, place) {
  // Get correct form to work with
  var gform_body = $('#'+addressID).closest('.gform_body');

  // Get the place details from the autocomplete object.
  var componentForm = window.onCarrot.addresses;
  for (var component in componentForm[addressID]) {
    gform_body.find('#'+componentForm[addressID][component].id).value = '';
    gform_body.find('#'+componentForm[addressID][component].id).disabled = false;
  }

  // Get each component of the address from the place details
  // and fill the corresponding field on the form.
  for (var i = 0; i < place.address_components.length; i++) {
    var addressType = place.address_components[i].types[0];
    if (componentForm[addressID][addressType] && addressType) {
      var val = place.address_components[i][componentForm[addressID][addressType].value];

      // Street name should be appended to address line 1
      if (addressType == 'route') {
        var streetnumber = gform_body.find('#'+componentForm[addressID]['street_number'].id);
        streetnumber.val(streetnumber.val() + ' ' + val);
      } else {
        gform_body.find('#'+componentForm[addressID][addressType].id).val(val);
      }
    }
  }

}

// Bias the autocomplete object to the user's geographical location,
// as supplied by the browser's 'navigator.geolocation' object.
export function geolocate(id) {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function(position) {
      var geolocation = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };
      var circle = new google.maps.Circle({
        center: geolocation,
        radius: position.coords.accuracy
      });
      autocompleteAddresses[id].setBounds(circle.getBounds());
    });
  }
}



// WEBPACK FOOTER //
// /site/web/app/plugins/oncarrot-address-autocomplete/gravity-forms-address-autocomplete.js